import React from "react";
import Side from "./Side";
import Index from "./Index";

export default function Main() {
  const click = (e) => {
    const target = e.target;
    target.style.color = "#0D86FF";
    console.log(target);
  };
  return (
    <div class="col-12 col-lg-9 col-md-8 p-0">
      <div class="row m-0">
        <Side margin={"mt-4"} display={"d-block d-lg-none"} click={click} />
        <Index />
        <Side margin={"mt2"} display={"d-none d-lg-block"} click={click} />
      </div>
    </div>
  );
}
